import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} fill={fillColor} x='0px' y='0px' viewBox='0 0 50 50' className={className}>
      <path d='M5,7v42h34v-6h6V1H11v6H5z M37,47H7V9h4h19v7h7v27V47z M32,10.414L35.586,14H32V10.414z M13,3h30v38h-4V14.586L31.414,7H13   V3z' />
      <rect height='2' width='22' x='11' y='20' />
      <rect height='2' width='22' x='11' y='26' />
      <rect height='2' width='22' x='11' y='32' />
      <rect height='2' width='9' x='11' y='40' />
      <rect height='2' width='9' x='24' y='40' />
      <rect height='2' width='8' x='18' y='14' />
    </svg>
  );
});

export default React.memo(Icon);
